// Copyright (c) 2016 Deere & Company

import PipCodeRequest from './components/pip-code-request';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.pips.pipCodeRequest
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PipCodeRequest);



// WEBPACK FOOTER //
// ./src/pip/pip-code/state-connector.js